import NetworkConnection from 'NetworkConnection';
import hideSplashScreen from 'hideSplashScreen';
import ClientStorage from 'ClientStorage';
import { type EventLogger, getUserAnalyticsData } from 'EventLogger';
import { type ErrorLogService } from 'ErrorLogging';
import { type FrontRoyalRootScope } from './FrontRoyal.types';

export function cleanUpRouteResolution($injector: ng.auto.IInjectorService) {
    try {
        const $rootScope = $injector.get<FrontRoyalRootScope>('$rootScope');

        hideSplashScreen($injector);

        if (NetworkConnection.online && $rootScope.currentUser) {
            const user = $rootScope.currentUser;

            // rather than try to direct this from a downstream directive, assume
            // the "welcome" page is whatever we initially redirect an unregistered user to
            // NOTE: may be preview session, so check that the method exists first.
            if (user.ensureHasSeenWelcome) {
                user.ensureHasSeenWelcome();
            }

            // We used to ensureLoginEvent in the handleValidationSuccess ValidationResponder
            // function, but we noticed that it was getting called multiple times quickly
            // during OAuth registration because of the redirects. So we moved it here
            // so that we call it when the app is hopefully at a stable point.
            // NOTE: may be preview session, so check that the method exists first.
            if (user.ensureLoginEvent) {
                const loginEventFired = user.ensureLoginEvent();

                // Marketing sets this cookie before redirecting individual cert_register flows
                // to the app so that we can log an event here without interruption.
                // Skip the log when ensureLoginEvent fired so we don't double-count the conversion.
                if (ClientStorage.getCookie('fire_cert_register')) {
                    ClientStorage.removeDomainCookie('fire_cert_register');
                    if (!loginEventFired) {
                        getUserAnalyticsData(user)
                            .then(userAnalyticsData => {
                                const EventLogger = $injector.get<EventLogger>('EventLogger');
                                EventLogger.log('cert_register', userAnalyticsData);
                                EventLogger.tryToSaveBuffer?.();
                            })
                            .catch(e => {
                                $injector.get<typeof ErrorLogService>('ErrorLogService').notify(e.message);
                            });
                    }
                }
            }
        }
    } catch (e) {
        console.error('Routing error: ', e);
        throw e;
    }
}
